// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1CpaG","content":"ManualTimeModal_content__1vEPe"};